import { render, staticRenderFns } from "./BannerSection.vue?vue&type=template&id=454882b8&scoped=true"
import script from "./BannerSection.vue?vue&type=script&lang=js"
export * from "./BannerSection.vue?vue&type=script&lang=js"
import style0 from "./BannerSection.vue?vue&type=style&index=0&id=454882b8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454882b8",
  null
  
)

export default component.exports